import type { GrainKind } from './piece-themes';

/** Le due varianti di ogni venatura: una per la parità/il colore chiaro, una per lo scuro. */
export interface GrainPair {
  light: string;
  dark: string;
}

/**
 * Id dei pattern di materiale, dichiarati UNA VOLTA SOLA da `<MaterialDefs />` e
 * referenziati da ogni pezzo.
 *
 * Vivono in un modulo a sé — e non dentro MaterialDefs.tsx — perché `Piece.tsx` deve
 * poterli importare senza tirarsi dietro il componente: `Piece` è montato fino a 40
 * volte per scacchiera, e la dipendenza inversa creerebbe un ciclo con `piece-themes`.
 *
 * Gli id sono FISSI e non derivati da `useId()`: in SVG inline `url(#id)` si risolve
 * sull'intero documento, quindi una singola dichiarazione serve scacchiera, anteprima,
 * swatch e icone catture. È anche l'unico modo sostenibile di avere una venatura per
 * pezzo: i `<defs>` di `Piece` sono per-pezzo e non deduplicati, e un pattern replicato
 * 40 volte per render sarebbe un moltiplicatore su un costo già alto.
 *
 * IL CONFINE DELLA REGOLA. Gli id restano fissi per ciò che è dichiarato una volta per
 * documento e riusato IDENTICO da ogni riferimento — questi pattern, il riflesso del
 * vetro. La maschera di parità della lastra non è di quella famiglia: la sua geometria
 * dipende dal lato della casella e dall'orientamento, che cambiano per ogni scacchiera
 * montata. Là gli id vengono da `useId()` (vedi `BoardSlab`), e non costa niente perché
 * di lastre ce n'è UNA per scacchiera, non quaranta come i pezzi.
 */
export const GRAIN_PATTERN_ID: Record<GrainKind, GrainPair> = {
  wood: { light: 'dg-grain-wood-light', dark: 'dg-grain-wood-dark' },
  marble: { light: 'dg-grain-marble-light', dark: 'dg-grain-marble-dark' },
};

/** Riflesso del vetro sulla scacchiera: non è una venatura, è una sfumatura di lucidità. */
export const SLAB_GLOSS_ID = 'dg-slab-gloss';
